// extracted by mini-css-extract-plugin
export var dark = "r_rh";
export var darkcookie = "r_rj";
export var tintedcookie = "r_rk";
export var regularcookie = "r_rl";
export var darkbase = "r_rm";
export var tintedbase = "r_rn";
export var regularbase = "r_rp";
export var darkraw = "r_rq";
export var tintedraw = "r_rr";
export var regularraw = "r_rs";
export var darkchick = "r_rt";
export var tintedchick = "r_rv";
export var regularchick = "r_rw";
export var darkherbarium = "r_rx";
export var tintedherbarium = "r_ry";
export var regularherbarium = "r_rz";
export var darkholiday = "r_rB";
export var tintedholiday = "r_rC";
export var regularholiday = "r_rD";
export var darkoffline = "r_rF";
export var tintedoffline = "r_rG";
export var regularoffline = "r_rH";
export var darkorchid = "r_rJ";
export var tintedorchid = "r_rK";
export var regularorchid = "r_rL";
export var darkpro = "r_rM";
export var tintedpro = "r_rN";
export var regularpro = "r_rP";
export var darkrose = "r_rQ";
export var tintedrose = "r_rR";
export var regularrose = "r_rS";
export var darktimes = "r_rT";
export var tintedtimes = "r_rV";
export var regulartimes = "r_rW";
export var darkwagon = "r_rX";
export var tintedwagon = "r_rY";
export var regularwagon = "r_rZ";